import React, { Component } from 'react';
import { connect } from "react-redux";
import { cloneDeep, debounce, filter, isEmpty, isNull, isEqual } from "lodash";
import * as static_list_actions from "../../store/static_list/actions";
import disease_api from "../../api/disease-api";

import QueryToolbar from './query-toolbar'
import ResultFilter from './result-filter';
import TableFooter from '../tables/table-footer';
import ModalDeletePatient from '../modal-delete-patient';
import ModalConfirmReportDelete from '../modal-confirm-report-delete';
import ActivityIndicator from '../../components/activity-indicator'
import family_api from "../../api/family-api";
import genetic_testing_api from "../../api/genetic-testing-api"
import ModalSaveReport from "./modal-save-report"
import ModalOverwriteReport from '../modal-overwrite-report';
import userAccountApi from '../../api/user-account-api';
import QueryTimeoutModal from './queryTimeoutModal';
import { resetFamilyRedux } from "../../helpers/helper-family-tree";
import helpers from "../../helpers/index";
import { radix_bases } from '../../helpers/helper-number-bases';
import route_helper from "../../route-helper";
import * as helper_search from '../../helpers/helper-search'
import json_columns from './columns.json';
import moment from 'moment';
import qs from 'qs';
import jsPDF from 'jspdf';
import ErrorSummary from '../../components/error-summary'
import "jspdf/dist/polyfills.es.js";
import 'jspdf-autotable'
import Select from 'react-select'
import { createUUID } from '../react-flow-pedigree/utils';

import OutsideAlerter from './OutsideAlerter';
import AdvancedFilters from './advanced-filters'

import $ from 'jquery'

import { buildQueryPayload } from './query-utils'
import {csvGenertor, pdfGenerator, copyGenerator} from '../../helpers/helper-query-docs'
import SurveyAPI from '../../api/survey-api';
import sdk from '../../api/sdk'

function parseToInt(val) {
  return parseInt(val, radix_bases.base10);
}
const MAX_PATIENTS = 75
const surveyAPI = new SurveyAPI();
let ac;

let scrollBar = {
  width: '100%',
  top: 70,
  display: 'none'
};

let thumb = {
  width: "50px"
}

let tableValues = {
  width: "100%",
  transform: ""
}

class ResultList extends Component {

  constructor(props) {
    super(props);
    this.queryToolbarRef = React.createRef();
    this.diseaseFilterRef = React.createRef();
    this.geneTestingFilterRef = React.createRef();
    this.referralFilterRef = React.createRef();
    this.moreFilterRef = React.createRef();
    this.resultFilterRef = React.createRef();
    this.state = {
      loading: false,
      probands: [],
      errorMessages: [],
      showSaveReport: false,
      showOverwriteReport: [false, ''],
      showDeletePatientModal: false,
      showDeleteReportModal: [false, ''],
      showQueryTimeoutModal: false,
      currentPatient: null,
      columns: [],
      querySurveyColumns: [],
      surveyColumns: [],
      allColumns: [],
      gender: null,
      page: 1,
      hasMore: true,
      reports: [],
      filters: [],
      surveyAnswers:[],
      diseases: {
        disease_filters: [
          // {
          //   andOr: 'and',
          //   items: [
          //     // { andOr: 'and', cancerType: 2, relationalOperator: '<', age: '46' },
          //     // { andOr: 'and', cancerType: 2, relationalOperator: '>', age: '44' },
          //     { andOr: 'and', cancerType: 2, relationalOperator: '>', age: '44' },
          //     { andOr: 'and', cancerType: 5, relationalOperator: '>', age: '44' },
          //     { andOr: 'or', cancerType: 3, relationalOperator: '=', age: '45' },
          //     { andOr: 'or', cancerType: 1, relationalOperator: '>', age: '33' },
          //   ],
          // },
          // {
          //   andOr: 'or',
          //   items: [
          //     { andOr: 'or', cancerType: 3, relationalOperator: '=', age: '45' },
          //   ],
          // },
          // {
          //   andOr: 'or',
          //   items: [
          //     { andOr: 'or', cancerType: 1, relationalOperator: '>', age: '33' },
          //   ],
          // },
        ]
      },
      genes: {
        gene_filters: []
      },
      referrals: {
        referral_filters: [
        ]
      },
      more_filters: {
      },
      dob: {
        sign: '',
        start_date: '',
        end_date: ''
      },
      age: {
        sign: '',
        age: '',
        age_to: ''
      },
      clinician: null,
      status: null,
      records_count: 0,
      isDiseaseFilterActive: false,
      isGeneFilterActive: false,
      isReferralCriteriaFilterActive: false,
      isMoreFiltersActive: false,
      includeUMLS: false,
      setFilterHashes: () => {},
      org_clinicians: [],
      currently_active_patient_for_clinician_column: '',
      currently_hovered_patient_for_clinician_column: '',
      active_ordered_filters: [],
      showAdvancedFilters: false,
      advanced_filters: [],
      familyFilters: {
        number_of_people_to_meet_criteria: {
          relationalOperator: 'any',
          value: ''
        },
        relationship: 'anyone'
      },
      active_advanced_filter: '',
      advanced_filters_results: {
        status: '',
        query_result_ID: '',
        result: []
      },
      current_query_uid: '',
      query_result_uid: '',
      show_add_filters: true,
      filter_class: '',
      isDragging: false,
      scrollPosition: 0,
      number_of_pedigrees_on_org: 0
    };

    this.handleEditColumn = this.handleEditColumn.bind(this)
    this.openDeletePatientModal = this.openDeletePatientModal.bind(this);
    this.openDeleteReportModal = this.openDeleteReportModal.bind(this);
    this.closeDeletePatientModal = this.closeDeletePatientModal.bind(this);
    this.changeDiseaseFilters = this.changeDiseaseFilters.bind(this);
    this.changeReferralFilters = this.changeReferralFilters.bind(this);
    this.downloadCSV = this.downloadCSV.bind(this);
    this.handleReorderColumns = this.handleReorderColumns.bind(this)

    this.copyText = this.copyText.bind(this);
    this.handleClearFilter = this.handleClearFilter.bind(this);
    this.trackScrolling = this.trackScrolling.bind(this);
    this.onSavePDF = this.onSavePDF.bind(this);
    this.changeGeneFilters = this.changeGeneFilters.bind(this);
    this.changeMoreFilters = this.changeMoreFilters.bind(this);
    this.handleIsActiveChange = this.handleIsActiveChange.bind(this);
    this.openSaveReportModal = this.openSaveReportModal.bind(this);
    this.closeReportModal = this.closeReportModal.bind(this);
    this.openOverwriteReportModal = this.openOverwriteReportModal.bind(this);
    this.closeOverwriteReportModal = this.closeOverwriteReportModal.bind(this);
    this.saveNewReport = this.saveNewReport.bind(this);
    this.fetchReports = this.fetchReports.bind(this);
    this.loadDefaultColumns = this.loadDefaultColumns.bind(this);
    this.getSetFilterHashes = this.getSetFilterHashes.bind(this);
    this.queryProbands = this.queryProbands.bind(this);
    this.addFamilyTimeStampToProband = this.addFamilyTimeStampToProband.bind(this);
    this.loadGenesFromApi = this.loadGenesFromApi.bind(this);
    this.loadDiseasesFromAPI = this.loadDiseasesFromAPI.bind(this);
    this.viewPatient = this.viewPatient.bind(this);
    this.setLocalStorage = this.setLocalStorage.bind(this);
    this.setCurrentlyActivePatientForClinicianColumn = this.setCurrentlyActivePatientForClinicianColumn.bind(this);
    this.setCurrentlyHoveredPatientForClinicianColumn = this.setCurrentlyHoveredPatientForClinicianColumn.bind(this);
    this.loadPatientStatus = this.loadPatientStatus.bind(this);
    this.addPatientStatus = this.addPatientStatus.bind(this);
    this.setShowAdvancedFilters = this.setShowAdvancedFilters.bind(this);
    this.setAdvancedFiltersResults = this.setAdvancedFiltersResults.bind(this);
    this.setAdvancedFilters = this.setAdvancedFilters.bind(this);
    this.setActiveAdvancedFilter = this.setActiveAdvancedFilter.bind(this);
    this.refreshProbands = this.refreshProbands.bind(this);
    this.setFamilyFilters = this.setFamilyFilters.bind(this);
    this.setLoadingState = this.setLoadingState.bind(this);
    this.resetAdvancedFiltersResults = this.resetAdvancedFiltersResults.bind(this);
    this.setShowAddFilters = this.setShowAddFilters.bind(this);
    this.getClinicianList = this.getClinicianList.bind(this);
    this.loadReportColumns = this.loadReportColumns.bind(this);
    this.setAdvancedQueryUIDs = this.setAdvancedQueryUIDs.bind(this);
    this.queryProbandsNew = this.queryProbandsNew.bind(this);
    this.getAllAdvancedPatientsDocuments = this.getAllAdvancedPatientsDocuments.bind(this);
    this.getAllStandarPatientsDocuments = this.getAllStandarPatientsDocuments.bind(this);
    this.runAdvancedQuery = this.runAdvancedQuery.bind(this);
    this.loadInitialData = this.loadInitialData.bind(this);
    this.addSurveyColumns = this.addSurveyColumns.bind(this);
    this.addSurveyAnswers = this.addSurveyAnswers.bind(this);
    this.closeQueryTimeoutModal = this.closeQueryTimeoutModal.bind(this);
    this.compareFloats = this.compareFloats.bind(this);
  }

  getSetFilterHashes(setFilterHashes){
    this.setState({setFilterHashes: setFilterHashes});
  }

  async getClinicianList() {
    try {

      const clin_list = await userAccountApi.get_clinician_list();
      this.setOrgClinicians(clin_list);

    } catch (error) {
      console.log(error);
    }
  }

  async componentDidMount() {
    this.mounted = true

    let sessionStorageQueryState = await JSON.parse(sessionStorage.getItem('query_state'))

    await this.getClinicianList();
    await this.loadDefaultColumns();

    if(sessionStorageQueryState !== undefined && sessionStorageQueryState !== null){
      if (sessionStorageQueryState.isDiseaseFilterActive || sessionStorageQueryState.isGeneFilterActive || sessionStorageQueryState.isReferralCriteriaFilterActive || sessionStorageQueryState.isMoreFiltersActive || sessionStorageQueryState.advanced_filters.length > 0 || sessionStorageQueryState.search){
        const search_text = sessionStorageQueryState.search;
        delete sessionStorageQueryState.search;
        helper_search.updateSearchText(this.props.dispatch, search_text);
        this.setState(sessionStorageQueryState, () => {
          this.resultFilterRef.current.setFilterStates(sessionStorageQueryState);
          if(sessionStorageQueryState.advanced_filters.length > 0){
            if(sessionStorageQueryState.advanced_filters_results.status == 'Running'){
              this.runAdvancedQuery();
            }
          }
        })
      }
      else{
        await this.queryProbands();
      }
    }
    else{
      await this.queryProbands();
    }

    await this.loadInitialData()

    this.props.setQueryProbands(this.refreshProbands);
    // this.setOrgClinicians(this.props.org_clinicians);
    resetFamilyRedux(this.props.dispatch);



    window.addEventListener('scroll', debounce(this.trackScrolling, 100), true);

    document.addEventListener('mousemove', this.handleDrag);
    this.checkOverflow();
  }

  componentDidUpdate() {
    this.checkOverflow();
    this.updateStickyHeader();
  }

  componentWillUnmount() {
    this.mounted = false
    window.removeEventListener('scroll', debounce(this.trackScrolling, 100), true);
    document.removeEventListener('mousemove', this.handleDrag);
  }

  async loadInitialData() {
    try {
      await Promise.all([
        await this.loadPatientStatus(),
        await this.loadGenesFromApi(),
        await this.loadDiseasesFromAPI(),
        await this.loadSurveysFromAPI(),
        await this.fetchReports(),
      ]);
      console.log("All async functions completed successfully.");
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  async refreshProbands(){
    await this.loadPatientStatus()
    await this.queryProbands()
  }

  setOrgClinicians(clins) {
    const org_clinicians = []
    for (let i=0; i<clins.length; i++) {
      const clinician = clins[i];
      const clinician_object = {
        value: String(clinician.user_id),
        label: `${clinician.first_name} ${clinician.last_name}`
      }
      org_clinicians.push(clinician_object);
    }

    this.setState({ org_clinicians: org_clinicians });
  }

  setLocalStorage() {
    const tokens = sessionStorage.getItem('famgenix_app_tokens');
    const extra_data = sessionStorage.getItem('extra_data');
    localStorage.setItem('famgenix_app_tokens', tokens);
    localStorage.setItem('extra_data', extra_data);
  }

  viewPatient(patient_id, renderer="CANVAS", event=null, member_id) {

    if(member_id){
      sessionStorage.setItem("member_id_toBeSelected", member_id)
    }

    if (event) {
      // check for right click
      var isRightMB;

      if ("which" in event.nativeEvent) { // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
        isRightMB = event.nativeEvent.which === 3;
      } else if ("button" in event.nativeEvent) {  // IE, Opera
        isRightMB = event.nativeEvent.button === 2;
      }

      if (renderer === "DOM" && (isRightMB || event.ctrlKey || event.metaKey)) {
        // temp set the sessionStorage to locaStorage
        this.setLocalStorage();

        const url = process.env.REACT_APP_SITE_URL+"/pedigree/" + patient_id;
        window.open(url, '_blank', 'noopener,noreferrer');
      } else if (isRightMB || event.ctrlKey || event.metaKey) {
        // temp set the sessionStorage to locaStorage
        this.setLocalStorage();

        const url = process.env.REACT_APP_SITE_URL+"/patient-profile/" + patient_id;
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        let url = url =
          route_helper.patient.patient_profile.replace(":member_id", patient_id) +
          "/#family-history";

        if (renderer === "DOM") {
          url =
            route_helper.pedigree.pedigree_root.replace(":member_id", patient_id) +
            "/#family-history";
        }

        this.props.history.push(url);
      }

    } else {
      let url = url =
        route_helper.patient.patient_profile.replace(":member_id", patient_id) +
        "/#family-history";

      if (renderer === "DOM") {
        url =
          route_helper.pedigree.pedigree_root.replace(":member_id", patient_id) +
          "/#family-history";
      }

      this.props.history.push(url);
    }
  }

  getLocaleDateString() {
    var formats = { "ar-SA": "DD/MM/YY", "bg-BG": "DD.MM.YYYY", "ca-ES": "DD/MM/YYYY", "zh-TW": "YYYY/MM/DD", "cs-CZ": "DD.MM.YYYY", "da-DK": "DD-MM-YYYY", "de-DE": "DD.MM.YYYY", "el-GR": "DD/MM/YYYY", "en-US": "MM/DD/YYYY", "fi-FI": "DD.MM.YYYY", "fr-FR": "DD/MM/YYYY", "he-IL": "DD/MM/YYYY", "hu-HU": "YYYY. MM. DD.", "is-IS": "DD.MM.YYYY", "it-IT": "DD/MM/YYYY", "ja-JP": "YYYY/MM/DD", "ko-KR": "YYYY-MM-DD", "nl-NL": "DD-MM-YYYY", "nb-NO": "DD.MM.YYYY", "pl-PL": "YYYY-MM-DD", "pt-BR": "DD/MM/YYYY", "ro-RO": "DD.MM.YYYY", "ru-RU": "DD.MM.YYYY", "hr-HR": "DD.MM.YYYY", "sk-SK": "DD. MM. YYYY", "sq-AL": "YYYY-MM-DD", "sv-SE": "YYYY-MM-DD", "th-TH": "DD/MM/YYYY", "tr-TR": "DD.MM.YYYY", "ur-PK": "DD/MM/YYYY", "id-ID": "DD/MM/YYYY", "uk-UA": "DD.MM.YYYY", "be-BY": "DD.MM.YYYY", "sl-SI": "DD.MM.YYYY", "et-EE": "DD.MM.YYYY", "lv-LV": "YYYY.MM.DD.", "lt-LT": "YYYY.MM.DD", "fa-IR": "MM/DD/YYYY", "vi-VN": "DD/MM/YYYY", "hy-AM": "DD.MM.YYYY", "az-Latn-AZ": "DD.MM.YYYY", "eu-ES": "YYYY/MM/DD", "mk-MK": "DD.MM.YYYY", "af-ZA": "YYYY/MM/DD", "ka-GE": "DD.MM.YYYY", "fo-FO": "DD-MM-YYYY", "hi-IN": "DD-MM-YYYY", "ms-MY": "DD/MM/YYYY", "kk-KZ": "DD.MM.YYYY", "ky-KG": "DD.MM.YY", "sw-KE": "MM/DD/YYYY", "uz-Latn-UZ": "DD/MM YYYY", "tt-RU": "DD.MM.YYYY", "pa-IN": "DD-MM-YY", "gu-IN": "DD-MM-YY", "ta-IN": "DD-MM-YYYY", "te-IN": "DD-MM-YY", "kn-IN": "DD-MM-YY", "mr-IN": "DD-MM-YYYY", "sa-IN": "DD-MM-YYYY", "mn-MN": "YY.MM.DD", "gl-ES": "DD/MM/YY", "kok-IN": "DD-MM-YYYY", "syr-SY": "DD/MM/YYYY", "dv-MV": "DD/MM/YY", "ar-IQ": "DD/MM/YYYY", "zh-CN": "YYYY/MM/DD", "de-CH": "DD.MM.YYYY", "en-GB": "DD/MM/YYYY", "es-MX": "DD/MM/YYYY", "fr-BE": "DD/MM/YYYY", "it-CH": "DD.MM.YYYY", "nl-BE": "DD/MM/YYYY", "nn-NO": "DD.MM.YYYY", "pt-PT": "DD-MM-YYYY", "sr-Latn-CS": "DD.MM.YYYY", "sv-FI": "DD.MM.YYYY", "az-Cyrl-AZ": "DD.MM.YYYY", "ms-BN": "DD/MM/YYYY", "uz-Cyrl-UZ": "DD.MM.YYYY", "ar-EG": "DD/MM/YYYY", "zh-HK": "DD/MM/YYYY", "de-AT": "DD.MM.YYYY", "en-AU": "DD/MM/YYYY", "es-ES": "DD/MM/YYYY", "fr-CA": "YYYY-MM-DD", "sr-Cyrl-CS": "DD.MM.YYYY", "ar-LY": "DD/MM/YYYY", "zh-SG": "DD/MM/YYYY", "de-LU": "DD.MM.YYYY", "en-CA": "DD/MM/YYYY", "es-GT": "DD/MM/YYYY", "fr-CH": "DD.MM.YYYY", "ar-DZ": "DD-MM-YYYY", "zh-MO": "DD/MM/YYYY", "de-LI": "DD.MM.YYYY", "en-NZ": "DD/MM/YYYY", "es-CR": "DD/MM/YYYY", "fr-LU": "DD/MM/YYYY", "ar-MA": "DD-MM-YYYY", "en-IE": "DD/MM/YYYY", "es-PA": "MM/DD/YYYY", "fr-MC": "DD/MM/YYYY", "ar-TN": "DD-MM-YYYY", "en-ZA": "YYYY/MM/DD", "es-DO": "DD/MM/YYYY", "ar-OM": "DD/MM/YYYY", "en-JM": "DD/MM/YYYY", "es-VE": "DD/MM/YYYY", "ar-YE": "DD/MM/YYYY", "en-029": "MM/DD/YYYY", "es-CO": "DD/MM/YYYY", "ar-SY": "DD/MM/YYYY", "en-BZ": "DD/MM/YYYY", "es-PE": "DD/MM/YYYY", "ar-JO": "DD/MM/YYYY", "en-TT": "DD/MM/YYYY", "es-AR": "DD/MM/YYYY", "ar-LB": "DD/MM/YYYY", "en-ZW": "MM/DD/YYYY", "es-EC": "DD/MM/YYYY", "ar-KW": "DD/MM/YYYY", "en-PH": "MM/DD/YYYY", "es-CL": "DD-MM-YYYY", "ar-AE": "DD/MM/YYYY", "es-UY": "DD/MM/YYYY", "ar-BH": "DD/MM/YYYY", "es-PY": "DD/MM/YYYY", "ar-QA": "DD/MM/YYYY", "es-BO": "DD/MM/YYYY", "es-SV": "DD/MM/YYYY", "es-HN": "DD/MM/YYYY", "es-NI": "DD/MM/YYYY", "es-PR": "DD/MM/YYYY", "am-ET": "DD/MM/YYYY", "tzm-Latn-DZ": "DD-MM-YYYY", "iu-Latn-CA": "DD/MM/YYYY", "sma-NO": "DD.MM.YYYY", "mn-Mong-CN": "YYYY/MM/DD", "gd-GB": "DD/MM/YYYY", "en-MY": "DD/MM/YYYY", "prs-AF": "DD/MM/YY", "bn-BD": "DD-MM-YY", "wo-SN": "DD/MM/YYYY", "rw-RW": "MM/DD/YYYY", "qut-GT": "DD/MM/YYYY", "sah-RU": "MM.DD.YYYY", "gsw-FR": "DD/MM/YYYY", "co-FR": "DD/MM/YYYY", "oc-FR": "DD/MM/YYYY", "mi-NZ": "DD/MM/YYYY", "ga-IE": "DD/MM/YYYY", "se-SE": "YYYY-MM-DD", "br-FR": "DD/MM/YYYY", "smn-FI": "DD.MM.YYYY", "moh-CA": "MM/DD/YYYY", "arn-CL": "DD-MM-YYYY", "ii-CN": "YYYY/mM/DD", "dsb-DE": "DD. MM. YYYY", "ig-NG": "DD/MM/YYYY", "kl-GL": "DD-MM-YYYY", "lb-LU": "DD/MM/YYYY", "ba-RU": "DD.MM.YY", "nso-ZA": "YYYY/MM/DD", "quz-BO": "DD/MM/YYYY", "yo-NG": "DD/MM/YYYY", "ha-Latn-NG": "DD/MM/YYYY", "fil-PH": "MM/DD/YYYY", "ps-AF": "DD/MM/YY", "fy-NL": "DD-MM-YYYY", "ne-NP": "MM/DD/YYYY", "se-NO": "DD.MM.YYYY", "iu-Cans-CA": "DD/MM/YYYY", "sr-Latn-RS": "DD.MM.YYYY", "si-LK": "YYYY-MM-DD", "sr-Cyrl-RS": "DD.MM.YYYY", "lo-LA": "DD/MM/YYYY", "km-KH": "YYYY-MM-DD", "cy-GB": "DD/MM/YYYY", "bo-CN": "YYYY/MM/DD", "sms-FI": "DD.MM.YYYY", "as-IN": "DD-MM-YYYY", "ml-IN": "DD-MM-YY", "en-IN": "DD-MM-YYYY", "or-IN": "DD-MM-YY", "bn-IN": "DD-MM-YY", "tk-TM": "DD.MM.YY", "bs-Latn-BA": "DD.MM.YYYY", "mt-MT": "DD/MM/YYYY", "sr-Cyrl-ME": "DD.MM.YYYY", "se-FI": "DD.MM.YYYY", "zu-ZA": "YYYY/MM/DD", "xh-ZA": "YYYY/MM/DD", "tn-ZA": "YYYY/MM/DD", "hsb-DE": "DD. MM. YYYY", "bs-Cyrl-BA": "DD.MM.YYYY", "tg-Cyrl-TJ": "DD.MM.YY", "sr-Latn-BA": "DD.MM.YYYY", "smj-NO": "DD.MM.YYYY", "rm-CH": "DD/MM/YYYY", "smj-SE": "YYYY-MM-DD", "quz-EC": "DD/MM/YYYY", "quz-PE": "DD/MM/YYYY", "hr-BA": "DD.MM.YYYY.", "sr-Latn-ME": "DD.MM.YYYY", "sma-SE": "YYYY-MM-DD", "en-SG": "DD/MM/YYYY", "ug-CN": "YYYY-MM-DD", "sr-Cyrl-BA": "DD.MM.YYYY", "es-US": "MM/DD/YYYY" }
    return formats[navigator.language] || 'DD/MM/YYYY';
  }

  openDeletePatientModal(patient) {
    this.setState({
      showDeletePatientModal: true,
      currentPatient: patient
    });
  }

  closeDeletePatientModal() {
    this.setState({
      showDeletePatientModal: false,
      currentPatient: null
    });
  }

  async loadGenesFromApi() {

    try{
        let data = await genetic_testing_api.get_genetic_testing()
        let umls_data = await genetic_testing_api.get_umls_genetic_testing(this.props.user.clinician_id)

      await this.props.dispatch(static_list_actions.initialize_genetic_testings(data));
      await this.props.dispatch(static_list_actions.initialize_genetic_testings_umls(umls_data.proband_genes));
    } catch (error) {
      console.log(error);
    }
  }

  async loadPatientStatus() {
    try{
        let status = await family_api.get_patient_status_list()
        await this.props.dispatch(static_list_actions.intialize_patients_status(status));
    } catch (error) {
      console.log(error);
    }
  }

  async loadDiseasesFromAPI() {

    try {
        let data = await disease_api.get_disease();
        let umls = await disease_api.get_umls_diseases(this.props.user.clinician_id)
        let diseases = data.diseases.sort((a, b) => {
          if (a.disease_name < b.disease_name) return -1;
          if (a.disease_name > b.disease_name) return 1;
          return 0;
        });


        const uniqueUMLS = Array.from(new Set(umls.umls_diseases.map(a=>a.umls_name))).map(name=>{
          return umls.umls_diseases.find(a =>a.umls_name === name)
        })

        let umls_diseases = uniqueUMLS.sort((a, b) => {
          if (a.umls_name < b.umls_name) return -1;
          if (a.umls_name > b.umls_name) return 1;
          return 0;
        })

        await this.props.dispatch(static_list_actions.initialize_diseases(diseases));
        await this.props.dispatch(static_list_actions.intitialize_umls(umls_diseases))
        await this.props.dispatch(static_list_actions.intitialize_disease_categories(data.disease_categories))
    } catch (error) {
      console.log(error);
    }
  }

  async loadSurveysFromAPI() {
    try {
      let access_token = null;
      let tokens = sdk.tokens_from_cookie();
      access_token = tokens.token.accessToken;
      const headers = { accessToken: access_token };
      const payload = {
        clinician_id: this.props.user.clinician_id,
      };

      // pull the survey from DB
      let request = await surveyAPI.getAllSurveys(payload, headers);
      let surveys = Object.values(request.data.surveys)
      await this.props.dispatch(static_list_actions.intitialize_surveys(surveys));

    } catch (error) {
      console.log(error);
    }
  }

  normalizeSurveyChoices(surveys){
    let final_surveys = []
    for(let key in surveys){
      final_surveys.push(surveys[key])
    }
    return final_surveys;
  }

  async onDeletePatient(proband_id) {
    if (parseToInt(proband_id)) {
      try {
        await family_api.delete_family({ proband_id });

        if (this.state.advanced_filters_results.status === "Completed") {
          const result_count = this.state.advanced_filters_results.result.length;
          let found = null;
          for (let i=0; i<result_count; i++) {
            const record = this.state.advanced_filters_results.result[i];
            if (record.proband.id === proband_id) {
              found = i;
              break
            }
          }

          if (found !== null) {
            const new_results = cloneDeep(this.state.advanced_filters_results);
            new_results.size -= 1;
            if (new_results.size < 0) {
              new_results.size = 0;
            }
            new_results.result.splice(found, 1);
            this.setState({ advanced_filters_results: new_results });
          }
        }

        const cloned = cloneDeep(this.state.probands);
        const new_probands = cloned.filter((proband) => {
          if (parseToInt(proband.id) !== parseToInt(proband_id)) {
            return proband;
          }
        });

        this.setState({ probands: new_probands, number_of_pedigrees_on_org: this.state.number_of_pedigrees_on_org - 1 });

      } catch (error) {
        console.log(error)
      }
    }
  }

  openSaveReportModal(){
    this.setState({
      showSaveReport: true
    });
  }

  closeReportModal(){
    this.setState({
      showSaveReport: false
    });
  }
  closeQueryTimeoutModal(){
    this.handleClearFilter()
    this.setState({ showQueryTimeoutModal: false });
  }

  openOverwriteReportModal(reportTitle){
    this.setState({ showOverwriteReport: [true, reportTitle] });
  }

  closeOverwriteReportModal(){
    this.setState({ showOverwriteReport: [false, ''] });
  }

  async overWriteReport(reportTitle){
    this.setState({ loading: true })
    const payload = {
      filters: {
        search: this.props.searchFilter.search_text,
        gender: this.state.gender,
        diseases: this.state.diseases,
        referrals: this.state.referrals,
        genes: this.state.genes,
        dob: this.state.dob,
        age: this.state.age,
        clinician: this.state.clinician,
        status: this.state.status,
        more_filters: this.state.more_filters,
        includeUMLS: this.state.includeUMLS,
        advanced_uid: this.state.current_query_uid,
        active_advanced_filters: this.state.active_advanced_filter,
        advanced_filters: this.state.advanced_filters
      },
      reportTitle: reportTitle,
      columns: this.state.allColumns,
      user_id: this.props.user.user_id
    }

    try {
      await userAccountApi.overwrite_report(payload, this.props.user.clinician_id)
      this.closeReportModal();

    } catch (error) {
      console.log(error);
    }

    helpers.delay(.2);
    this.fetchReports();
    this.setState({loading: false});
  }

  ciEquals(a, b) {
    return typeof a === 'string' && typeof b === 'string'
      ? a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
      : a === b;
  }

  async saveNewReport(reportTitle) {
    let reports = this.state.reports.filter(report => this.ciEquals(report.title, reportTitle));
    if (reports.length > 0) {
      this.openOverwriteReportModal(reportTitle);
    }
    else {
      this.setState({ loading: true })

      const payload = {
        filters: {
          search: this.props.searchFilter.search_text,
          gender: this.state.gender,
          diseases: this.state.diseases,
          referrals: this.state.referrals,
          genes: this.state.genes,
          dob: this.state.dob,
          age: this.state.age,
          clinician: this.state.clinician,
          status: this.state.status,
          more_filters: this.state.more_filters,
          advanced_uid: this.state.current_query_uid,
          active_advanced_filters: this.state.active_advanced_filter,
          advanced_filters: this.state.advanced_filters,
          filter_class: this.state.filter_class
        },
        reportTitle: reportTitle,
        columns: this.state.allColumns,
        user_id: this.props.user.user_id
      }

      try {
        await userAccountApi.save_new_query_report(payload, this.props.user.clinician_id)
        this.closeReportModal();

      } catch (error) {
        console.log(error)
      }

      helpers.delay(.2)
      this.fetchReports()
      this.setState({loading: false})
    }
  }

  async fetchReports() {
    try{
      let reports = await userAccountApi.get_reports(this.props.user.organization_id, this.props.user.clinician_id);
      this.setState({reports: reports})
    } catch(error){
      this.setState({ errorMessages: [error.message] })
    }
  }

  loadReportColumns(reportColumns){
    if(reportColumns !== null && reportColumns !== undefined ){
      if (reportColumns !== json_columns.length){
        const gender_Selected = reportColumns.find(col=> (col.value == 'gender' && col.checked == true))
        const objectsOnlyInArray1 = json_columns.filter(obj1 => !reportColumns.find(obj2 => obj2.value === obj1.value));
        objectsOnlyInArray1.forEach(column =>{
          column['checked'] = false
          if(gender_Selected && column.value == "sex_at_birth") {
            column.checked = true
          }else{
            column['checked'] = false

          }
            reportColumns.push(column)
        })
      }
      const finalColumns =  reportColumns.filter(obj => {
        return obj.value !== 'gender'
      });

      return finalColumns

    }else{
      return json_columns

    }
  }

  loadReport = async(report) => {
    this.setState({loading: true})
      if(report == null){
       await this.handleClearFilter()
       await this.state.setFilterHashes();
      }else{

       try{
         let report_data  = await userAccountApi.load_report(report, this.props.user.clinician_id);


         if ('advanced_uid' in report_data.filters &&
              'filter_class' in report_data.filters &&
              report_data.filters.filter_class == 'advanced' &&
              report_data.filters.advanced_uid !== undefined &&
              report_data.filters.advanced_uid !== "") {

              let uid = report_data.filters.advanced_uid
              let advanced_filters = report_data.filters.advanced_filters
              let active_advanced_filters = report_data.filters.active_advanced_filters

              let updatedColumns = this.loadReportColumns(report_data.columns)
              let selected_columns = updatedColumns.filter(item => item.checked)

              this.setState({columns: selected_columns, allColumns: updatedColumns})

              await this.runReportAdvancedQuery(uid, advanced_filters, active_advanced_filters)

         }else{
            let filters = report_data.filters
            let updatedColumns = this.loadReportColumns(report_data.columns)
            // const payload = {
            //   search: filters.search_text,
            //   gender: filters.gender,
            //   diseases: filters.diseases,
            //   referrals: filters.referrals,
            //   genes: filters.genes,
            //   more_filters: filters.more_filters,
            //   dob: filters.dob,
            //   age: filters.age,
            //   clinician: filters.clinician
            // };

            this.resultFilterRef.current.handleHideAllFilters();

            if(filters.diseases.disease_filters.length > 0){
             this.resultFilterRef.current.handleClickAddFiltersOption(null, 'disease')
            }
            if(filters.genes.gene_filters.length > 0){
             this.resultFilterRef.current.handleClickAddFiltersOption(null, 'genetic_testing')
            }
            if(filters.referrals.referral_filters.length > 0){
             this.resultFilterRef.current.handleClickAddFiltersOption(null, 'referral_criteria')
            }
            if(!isEmpty(filters.more_filters)){
             this.resultFilterRef.current.handleClickAddFiltersOption(null, 'more')
            }
            // let probands = await family_api.query_probands(
            //   this.props.user.clinician_id, payload
            // );
            let selected_columns = updatedColumns.filter(item => item.checked)
            // this.addDiseasesToProband(probands.members, probands.member_diseases)
            // this.addGenesToProband(probands.members, probands.member_genes)
            // this.addPatientStatus(probands.members)
            // this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)

            if(filters.diseases.disease_filters.length > 0){
              for(let filter of filters.diseases.disease_filters){
                for(let item of filter.items){
                  item.fieldType = 'disease';
                }
              }
            }

            if(filters.genes.gene_filters.length > 0){
              for(let filter of filters.genes.gene_filters){
                for(let item of filter.items){
                  item.fieldType = 'genetic_testing';
                }
              }
            }

            let referral_num_compare = {
              "1": "any",
              "2": "none",
              "3": "breast/ovarian",
              "4": "colorectal",
              "5": "other"
            }

            if(filters.referrals.referral_filters.length > 0){
              for(let filter of filters.referrals.referral_filters){
                for(let item of filter.items){
                  item.fieldType = 'referral_criteria';
                  if(parseInt(item.referral, 10).toString() === item.referral) {
                    item.referral = referral_num_compare[item.referral]
                  }
                }
              }
            }

            if(this.diseaseFilterRef.current) await this.diseaseFilterRef.current.loadReportSetFilters(filters.diseases)
            if(this.geneTestingFilterRef.current) await this.geneTestingFilterRef.current.loadReportSetFilters(filters.genes)
            if(this.referralFilterRef.current) await this.referralFilterRef.current.loadReportSetFilters(filters.referrals)
            if(this.moreFilterRef.current) await this.moreFilterRef.current.loadReportSetFilters(filters.more_filters)

            this.setState({
              search: filters.search_text,
              gender: filters.gender,
              diseases: filters.diseases,
              referrals: filters.referrals,
              genes: filters.genes,
              dob: filters.dob,
              age: filters.age,
              more_filters: filters.more_filters,
              columns: selected_columns,
              allColumns: updatedColumns,
              // records_count: probands.records_count,
              clinician: filters.clinician,
              status: filters.status,
              filter_class: 'standard'
            }, async() => await this.queryProbandsNew());
        }
       }
        catch(error){
         console.log(error)
      }
    }

    this.setState({loading: false})
    this.saveFilterSettingsToSessionStorage();

  }

  async deleteReport() {
    this.setState({loading: true})
    try {
      await userAccountApi.delete_report(this.state.showDeleteReportModal[1].value, this.props.user.clinician_id);
      await this.fetchReports();
      if(this.state.showDeleteReportModal[1].value === this.queryToolbarRef.current.state.currentActiveReport.value || this.queryToolbarRef.current.state.currentActiveReport.value === null){
        await this.queryToolbarRef.current.selectRef.select.clearValue();
        await this.handleClearFilter();
      }
    }
    catch (error) {
      console.log(error)
    }
    this.setState({ showDeleteReportModal: [false, '']});
    this.setState({loading: false})
  }

  openDeleteReportModal(report){
    this.setState({ showDeleteReportModal: [true, report] });
  }

  closeDeleteReportModal(){
    this.setState({ showDeleteReportModal: [false, ''] });
  }

  handleReorderColumns(columns, all_columns) {
    this.setState({ columns: columns, allColumns: all_columns})
  }
  
  addSurveyColumns(newSurveyColumns) {
    let currentColumns = cloneDeep(this.state.allColumns);
    let newColumns = [];
    let prevSurveyColumns = currentColumns.filter(col => col.isSurveyColumn);

    newSurveyColumns.forEach(col => {
        if (!prevSurveyColumns.some(obj => obj.value === col.value)) {
            newColumns.push(col);
            prevSurveyColumns.push(col);
        }
    });

    const updatedColumns = [...currentColumns, ...newColumns];
    let checkedColumns = this.checkedColumns(updatedColumns);

    this.setState({
        columns: checkedColumns,
        allColumns: updatedColumns,
        surveyColumns: prevSurveyColumns
    });
}

  handleEditColumn(columns, all_columns) {
    this.addDiseasesToProband(this.state.probands, this.state.member_diseases)
    this.addGenesToProband(this.state.probands, this.state.member_genes)
    this.addReferralCriteriasToProband(this.state.probands, this.state.member_referral_criteria)
    this.addPatientStatus(this.state.probands)
    this.addSurveyAnswers(this.state.probands, this.state.surveyAnswers)
    this.setState({ columns: columns, allColumns: all_columns})
    this.checkOverflow();
    this.updateScrollbarPosition();
  }

  checkedColumns(columns){
    let display = []
    columns.forEach(column => {
      if(column.checked){
        display.push(column)
      }
    })
    return display
  }
  
  showColumn(key) {
    return this.state.columns.includes(key)
  }

  async loadDefaultColumns(){
    let selected_columns
      try{
          this.setState({loading: true})
          let columns = await userAccountApi.load_default_columns(this.props.user.organization_id, this.props.user.clinician_id)

          if(columns.default_columns !== null && columns.default_columns !== undefined ){
            if (columns.default_columns.length !== json_columns.length){
              const objectsOnlyInArray1 = json_columns.filter(obj1 => !columns.default_columns.find(obj2 => obj2.value === obj1.value));
              objectsOnlyInArray1.forEach(column =>{
                column['checked'] = false
                columns.default_columns.push(column)
              })
            }
            const finalColumns =  columns.default_columns.filter(obj => {
              return obj.value !== 'gender'
            });
            this.columnRef = finalColumns
            selected_columns = finalColumns.filter(item => item.checked)

            this.setState({ columns: selected_columns, allColumns: finalColumns})
          }else{
            this.columnRef = json_columns
            this.setState({allColumns: json_columns})
            selected_columns = json_columns.filter(item => item.checked)
            this.setState({ columns: selected_columns})
          }
      }catch(err){
        console.log(err)
      }finally{
        this.setState({loading: false})
      }
    }

  queryProbands = async() => {
    try{
      this.setState({loading: true});
      const payload = {
        search: this.props.searchFilter.search_text,
        gender: this.props.searchFilter.search_text ? null : this.state.gender,
        page: this.props.searchFilter.search_text ? 1 : this.state.page,
        diseases: this.props.searchFilter.search_text ? {disease_filters: []} : this.state.diseases,
        includeUMLS: this.props.searchFilter.search_text ? false : this.state.includeUMLS,
        referrals: this.props.searchFilter.search_text ? {referral_filters: []} : this.state.referrals,
        genes: this.props.searchFilter.search_text ? {gene_filters: []} : this.state.genes,
        dob: this.props.searchFilter.search_text ? {sign: '',start_date: '',end_date: ''} : this.state.dob,
        age: this.props.searchFilter.search_text ? {sign: '',age: '',age_to: ''} : this.state.age,
        clinician: this.props.searchFilter.search_text ? null : this.state.clinician,
        status: this.props.searchFilter.search_text ? null : this.state.status,
        more_filters: this.props.searchFilter.search_text ? {} : this.state.more_filters
      };

      let probands = await family_api.query_probands(
        this.props.user.clinician_id, payload
      );

      this.addDiseasesToProband(probands.members, probands.member_diseases)
      this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
      this.addGenesToProband(probands.members, probands.member_genes)
      this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
      this.addPatientStatus(probands.members)
      this.addSurveyAnswers(probands.members, probands.survey_answers)
      probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
      this.setState({
        probands: probands.members,
        member_diseases: probands.member_diseases,
        member_genes: probands.member_genes,
        member_referral_criteria: probands.member_referral_criteria,
        records_count: probands.records_count,
        number_of_pedigrees_on_org: probands.number_of_pedigrees_on_org,
        surveyAnswers: probands.survey_answers
      });

      if(this.props.searchFilter.search_text){
        this.resetAdvancedFiltersResults();
        this.setState({
          diseases: {
            disease_filters: []
          },
          genes: {
            gene_filters: []
          },
          referrals: {
            referral_filters: []
          },
          more_filters: {},
          includeUMLS: false,
          gender: null,
          dob: {
            sign: '',
            start_date: '',
            end_date: ''
          },
          age: {
            sign: '',
            age: '',
            age_to: ''
          },
          active_ordered_filters: [],
          clinician: null,
          status: null,
          hasMore: true,
          page: 1,
          isDiseaseFilterActive: false,
          isGeneFilterActive: false,
          isReferralCriteriaFilterActive: false,
          isMoreFiltersActive: false
        }, () => {
          this.resultFilterRef.current.handleClearFilterSets();
        });
      }
    } catch (error){
      this.setState({ errorMessages: [error.message] })
    }finally{
      if(this.mounted) {
        this.setState({ loading: false }, () => {
          this.saveFilterSettingsToSessionStorage();
        });
      }
    }

  }

  async queryProbandsNew(){
    try{
      let umls_genes = this.props.static_list.genetic_testings_umls
      let umls_diseases = this.props.static_list.umls_diseases
      let diseases = this.props.static_list.diseases
      let disease_categories = this.props.static_list.disease_categories

      const other_standard_data = {
        search: this.props.searchFilter.search_text,
        gender: this.state.gender,
        dob: this.state.dob,
        age: this.state.age,
        clinician: this.state.clinician,
        status: this.state.status,
        more_filters: this.state.more_filters
      };

      let trigger_other_standard_filters = this.state.isMoreFiltersActive || this.props.searchFilter.search_text

      let filterSets = []
      filterSets = filterSets.concat(this.state.diseases.disease_filters)
      filterSets = filterSets.concat(this.state.genes.gene_filters)
      filterSets = filterSets.concat(this.state.referrals.referral_filters)

      let payload = buildQueryPayload('probands', cloneDeep(filterSets), this.state.familyFilters, umls_genes, umls_diseases, diseases, disease_categories, true, trigger_other_standard_filters, other_standard_data)
      let request = await family_api.query_search(payload)

      let result_payload = {
        query_result_ID: request.query_result_ID
      }

      this.setAdvancedQueryUIDs(request.query_ID, request.query_result_ID)
      this.setAdvancedFiltersResults(result_payload, 'standard')
    }
    catch(e){
      console.log(e.stack)
    }

  }

  addFamilyTimeStampToProband(probands, timeStamps){
    let addtimestamp = timeStamps.reduce((results, time) => {
      (results[time.family_id] = results[time.family_id] || []).push(time)
      return results
    }, {})

    for (let patient of probands) {
      if (patient.family_id in addtimestamp) {
        patient.family_last_modified = addtimestamp[patient.family_id][0].last_modified
      }
    }
  }


  addPatientStatus(members){
    const complete = 'Complete'
    const inProgress = 'In Progress'

    if(!isEmpty(this.props.static_list.patients_status)){
      for(let patient of members){
        if(this.props.static_list.patients_status['complete_onboarding']
            && this.props.static_list.patients_status['complete_onboarding'].includes(patient.family_id)){
                patient.patient_status = complete

              }else if(this.props.static_list.patients_status['in_progress']
              && this.props.static_list.patients_status['in_progress'].includes(patient.family_id)){
                  patient.patient_status = inProgress
        }
      }
    }
  }
  addSurveyAnswers(members, surveyAnswers){

    // let memberSurveys = surveyAnswers.reduce((results, survey) => {
    //   (results[survey.member_id] = results[survey.member_id] || []).push(survey)
    //   return results
    // }, {})

    // for (let patient of members) {
    //   if (patient.id in memberSurveys) {
    //     patient.survey_answers = memberSurveys[patient.id]
    //   }
    // }
  }

  addDiseasesToProband(probands, diseases) {
    let group_diseases = []

    for (let diseases_list of diseases) {
      diseases_list.name = this.props.static_list.diseases.find(disease => {
        return disease.id == diseases_list.disease_id
      })
      group_diseases.push(diseases_list)
    }
    let groupMemberDiseases = diseases.reduce((results, disease) => {
      (results[disease.member_id] = results[disease.member_id] || []).push(disease)
      return results
    }, {})

    for (let patient of probands) {
      if (patient.id in groupMemberDiseases) {
        patient.diseases = groupMemberDiseases[patient.id]
      }
    }
  }

  addGenesToProband(probands, genes) {
    let group_genes = []
    for (let gene_list of genes) {
      gene_list.name = this.props.static_list.genetic_testings.find(gene => {
        return gene.id == gene_list.gene_id
      })
      group_genes.push(gene_list)
    }
    let groupMemberGenes = genes.reduce((results, genes) => {
      (results[genes.member_id] = results[genes.member_id] || []).push(genes)
      return results
    }, {})

    for (let patient of probands) {
      if (patient.id in groupMemberGenes) {
        patient.gene_summary = groupMemberGenes[patient.id]
      }
    }
  }

  addReferralCriteriasToProband(probands, referral_criterias){
    for(let proband of probands){
      let proband_referral_condition_array = []
      if(proband.id in referral_criterias){
        for (let criteria of referral_criterias[proband.id]){
          proband_referral_condition_array.push(criteria.condition_name)
        }
      }
      proband_referral_condition_array = proband_referral_condition_array.filter((v, i, a) => a.indexOf(v) === i)
      proband.referral_condition = proband_referral_condition_array
      let proband_referral_criteria_string = proband.referral_condition.join();
      let stringforReferralCriteria = this.getReferralCriteriaString(proband_referral_criteria_string)

      proband.referral_criteria_string = stringforReferralCriteria;
    }
  }

  getReferralCriteriaString(proband_referral_criteria_string){
    let stringforReferralCriteria = ""
    if(proband_referral_criteria_string.includes('Breast/Ovarian')){
      stringforReferralCriteria += "Breast/Ovarian" + ", ";
    }
    if(proband_referral_criteria_string.includes('Colorectal')){
      stringforReferralCriteria += "Colorectal" + ", ";
    }
    if(proband_referral_criteria_string.includes('Other')){
      stringforReferralCriteria += "Other" + ", ";
    }
    if(proband_referral_criteria_string.includes('Gene')){
      stringforReferralCriteria += "Gene" + ", ";
    }
    stringforReferralCriteria = stringforReferralCriteria.slice(0, -2)

    return stringforReferralCriteria;
  }

  async handleIsActiveChange(filter_name, isActive){
    if(filter_name === 'disease'){
      this.setState({ isDiseaseFilterActive: isActive })
    }
    else if(filter_name === 'gene'){
      this.setState({ isGeneFilterActive: isActive })
    }
    else if(filter_name === 'referral'){
      this.setState({ isReferralCriteriaFilterActive: isActive })
    }
    else if(filter_name === 'more_filters'){
      this.setState({ isMoreFiltersActive: isActive })
    }
  }

  async changeReferralFilters(referral_filters, isActive) {
    if(isActive){
      this.setState({
        referrals: {
          referral_filters: referral_filters
        }
      }, async() => await this.queryProbandsNew());
    }
    else{
      this.setState({
        referrals: {
          referral_filters: [
          ]
        }
      }, async() => await this.queryProbandsNew());
    }

    // const payload = {
    //   search: this.props.searchFilter.search_text,
    //   gender: this.state.gender,
    //   page: this.state.page,
    //   diseases: this.state.diseases,
    //   includeUMLS: this.state.includeUMLS,
    //   referrals: {
    //     referral_filters: isActive ? referral_filters : []
    //   },
    //   genes: this.state.genes,
    //   dob: this.state.dob,
    //   age: this.state.age,
    //   clinician: this.state.clinician
    // };

    // let probands = await family_api.query_probands(
    //   this.props.user.clinician_id, payload
    // );
    // this.addDiseasesToProband(probands.members, probands.member_diseases)
    // this.addGenesToProband(probands.members, probands.member_genes)
    // this.addPatientStatus(probands.members)
    // this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
    // probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
    // this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
    // this.setState({
    //   probands: probands.members,
    //   member_diseases: probands.member_diseases,
    //   member_genes: probands.member_genes,
    //   member_referral_criteria: probands.member_referral_criteria,
    //   records_count: probands.records_count,
    //   hasMore: true,
    //   page: 1
    // });

    // if(this.state.isGeneFilterActive || this.state.isDiseaseFilterActive || this.state.isMoreFiltersActive){
    //   await this.queryProbands();
    // }

    this.saveFilterSettingsToSessionStorage();

  }

  async changeDiseaseFilters(disease_filters, includeUMLS, isActive) {
    if(isActive){
      this.setState({
        diseases: {
          disease_filters: disease_filters
        },
        includeUMLS: includeUMLS
      }, async() => await this.queryProbandsNew());
    }
    else{
      this.setState({
        diseases: {
          disease_filters: [
          ]
        }
      }, async() => await this.queryProbandsNew());
    }


    // const payload = {
    //   search: this.props.searchFilter.search_text,
    //   gender: this.state.gender,
    //   page: this.state.page,
    //   diseases: {
    //     disease_filters: isActive ? disease_filters : []
    //   },
    //   includeUMLS: includeUMLS,
    //   referrals: this.state.referrals,
    //   genes: this.state.genes,
    //   dob: this.state.dob,
    //   age: this.state.age,
    //   clinician: this.state.clinician
    // };

    // let probands = await family_api.query_probands(
    //   this.props.user.clinician_id, payload
    // );

    // this.addDiseasesToProband(probands.members, probands.member_diseases)
    // this.addGenesToProband(probands.members, probands.member_genes)
    // this.addPatientStatus(probands.members)
    // this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
    // probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
    // this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
    // this.setState({
    //   probands: probands.members,
    //   member_diseases: probands.member_diseases,
    //   member_genes: probands.member_genes,
    //   member_referral_criteria: probands.member_referral_criteria,
    //   records_count: probands.records_count,
    //   hasMore: true,
    //   page: 1
    // });

    // if(this.state.isGeneFilterActive || this.state.isReferralCriteriaFilterActive || this.state.isMoreFiltersActive){
    //   await this.queryProbands();
    // }

    this.saveFilterSettingsToSessionStorage();

  }

  async changeGeneFilters(genes_filters, isActive) {
    if(isActive){
      this.setState({
        genes: {
          gene_filters: genes_filters
        }
      }, async() => await this.queryProbandsNew());
    }
    else{
      this.setState({
        genes: {
          gene_filters: []
        }
      }, async() => await this.queryProbandsNew());
    }

    // const payload = {
    //   search: this.props.searchFilter.search_text,
    //   gender: this.state.gender,
    //   page: this.state.page,
    //   diseases: this.state.diseases,
    //   referrals: this.state.referrals,
    //   includeUMLS: this.state.includeUMLS,
    //   genes: {
    //     gene_filters: isActive ? genes_filters : []
    //   },
    //   dob: this.state.dob,
    //   age: this.state.age,
    //   clinician: this.state.clinician
    // };

    // let probands = await family_api.query_probands(
    //   this.props.user.clinician_id, payload
    // );

    // this.addGenesToProband(probands.members, probands.member_genes)
    // this.addDiseasesToProband(probands.members, probands.member_diseases)
    // this.addPatientStatus(probands.members)
    // this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
    // probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
    // this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
    // this.setState({
    //   probands: probands.members,
    //   member_diseases: probands.member_diseases,
    //   member_genes: probands.member_genes,
    //   member_referral_criteria: probands.member_referral_criteria,
    //   records_count: probands.records_count,
    //   hasMore: true,
    //   page: 1
    // });

    // if(this.state.isDiseaseFilterActive || this.state.isReferralCriteriaFilterActive || this.state.isMoreFiltersActive){
    //   await this.queryProbands();
    // }

    this.saveFilterSettingsToSessionStorage();

  }

  async changeMoreFilters(more_filters, isActive){
    if(isActive){
      this.setState({
        more_filters: more_filters,
        gender: more_filters.gender,
        dob:{
          sign: more_filters.dob_operator,
          start_date: more_filters.dob_from,
          end_date: more_filters.dob_to
        },
        age: {
          sign: more_filters.age_operator,
          age: more_filters.age,
          age_to: more_filters.age_to
        },
        clinician: more_filters.clinician,
        status: more_filters.status
      }, () => this.queryProbandsNew());
    }
    else{
      more_filters.age = null
      more_filters.age_operator = "="
      more_filters.age_to = null
      more_filters.dob_from = null
      more_filters.dob_operator = "="
      more_filters.dob_to = null
      more_filters.gender = null
      more_filters.clinician = null
      more_filters.status = null
      this.setState({
        more_filters: more_filters,
        gender: more_filters.gender,
        dob:{
          sign: more_filters.dob_operator,
          start_date: more_filters.dob_from,
          end_date: more_filters.dob_to
        },
        age: {
          sign: more_filters.age_operator,
          age: more_filters.age,
          age_to: more_filters.age_to
        },
        clinician: more_filters.clinician,
        status: more_filters.status
      }, () => this.queryProbandsNew());
    }
    // const payload = {
    //   search: this.props.searchFilter.search_text,
    //   gender: more_filters.gender,
    //   page: this.state.page,
    //   diseases: this.state.diseases,
    //   includeUMLS: this.state.includeUMLS,
    //   referrals: this.state.referrals,
    //   genes: this.state.genes,
    //   more_filters: more_filters,
    //   dob:{
    //       sign: more_filters.dob_operator,
    //       start_date: more_filters.dob_from,
    //       end_date: more_filters.dob_to
    //   },
    //   age: {
    //     sign: more_filters.age_operator,
    //     age: more_filters.age,
    //     age_to: more_filters.age_to
    //   },
    //   clinician: more_filters.clinician
    // };

    // let probands = await family_api.query_probands(
    //   this.props.user.clinician_id, payload
    // );

    // this.setState({
    //   probands: probands.members,
    //   member_diseases: probands.member_diseases,
    //   member_genes: probands.member_genes,
    //   member_referral_criteria: probands.member_referral_criteria,
    //   records_count: probands.records_count,
    //   hasMore: true,
    //   page: 1,
    //   gender: more_filters.gender,
    //   dob:{
    //     sign: more_filters.dob_operator,
    //     start_date: more_filters.dob_from,
    //     end_date: more_filters.dob_to
    //   },
    //   age: {
    //     sign: more_filters.age_operator,
    //     age: more_filters.age,
    //     age_to: more_filters.age_to
    //   },
    //   clinician: more_filters.clinician
    // });

    // this.addGenesToProband(probands.members, probands.member_genes)
    // this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
    // probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
    // this.addDiseasesToProband(probands.members, probands.member_diseases)
    // this.addPatientStatus(probands.members)
    // this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)

    if(this.state.isGeneFilterActive || this.state.isReferralCriteriaFilterActive || this.state.isDiseaseFilterActive){
      await this.queryProbands();
    }

    this.saveFilterSettingsToSessionStorage();

  }

  async runAdvancedQuery(new_page=1){
    try{
      let max_people = MAX_PATIENTS * new_page

      // let umls_genes = this.props.static_list.genetic_testings_umls
      // let umls_diseases = this.props.static_list.umls_diseases

      // let payload = buildQueryPayload(this.state.active_advanced_filter, this.state.advanced_filters, this.state.familyFilters, umls_genes, umls_diseases, false)

      // doesn't need to rebuild, just send the query id
      let query_id = this.state.current_query_uid
      if (!query_id) return;

      let payload = {
        queryID: query_id,
        async: true
      }

      let request = await family_api.query_search(payload)

      let result_payload = {
        query_result_ID: request.query_result_ID,
        max: max_people
      }
      this.setAdvancedFiltersResults(result_payload, this.state.filter_class)
    }
    catch(e){
      console.log(e.stack)
    }
  }

  async runReportAdvancedQuery(query_id, advanced_filters, active_advanced_filters){
    try{
      let payload = {
        queryID: query_id
      }
      let request = await family_api.query_search(payload)
      let max_people = MAX_PATIENTS

      let result_payload = {
        query_result_ID: request.query_result_ID,
        max: max_people
      }

      this.setActiveAdvancedFilter(active_advanced_filters)
      this.setAdvancedFilters(advanced_filters)
      this.setAdvancedQueryUIDs(request.query_ID, request.query_result_ID)
      this.setAdvancedFiltersResults(result_payload, 'advanced')
    }
    catch(e){
      console.log(e.stack)
    }
  }

  async handleClearFilter() {
    const payload = {
      search: '',
      gender: null,
      page: 1,
      diseases: {
        disease_filters: []
      },
      referrals: {
        referral_filters: []
      },
      genes: {
        gene_filters: []
      },
      more_filters: {},
      dob: {
        sign: '',
        start_date: '',
        end_date: ''
      },
      age: {
        sign: '',
        age: '',
        age_to: ''
      },
      clinician: null,
      status: null,
      includeUMLS: false
    };

    this.resetAdvancedFiltersResults()
    this.setState({ active_ordered_filters: [] })

    let probands = await family_api.query_probands(
      this.props.user.clinician_id, payload
    );
    this.addDiseasesToProband(probands.members, probands.member_diseases)
    this.addGenesToProband(probands.members, probands.member_genes)
    this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
    this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
    this.addPatientStatus(probands.members)
    this.addSurveyAnswers(probands.members, probands.survey_answers)
    this.loadDefaultColumns()
    probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
    helper_search.updateSearchText(this.props.dispatch, '');
    this.setState({
      diseases: {
        disease_filters: []
      },
      genes: {
        gene_filters: []
      },
      referrals: {
        referral_filters: []
      },
      more_filters: {},
      probands: probands.members,
      member_diseases: probands.member_diseases,
      member_genes: probands.member_genes,
      member_referral_criteria: probands.member_referral_criteria,
      records_count: probands.records_count,
      includeUMLS: false,
      gender: null,
      dob: {
        sign: '',
        start_date: '',
        end_date: ''
      },
      age: {
        sign: '',
        age: '',
        age_to: ''
      },
      clinician: null,
      status: null,
      hasMore: true,
      page: 1,
      isDiseaseFilterActive: false,
      isGeneFilterActive: false,
      isReferralCriteriaFilterActive: false,
      isMoreFiltersActive: false
    });

    // removal of query state on sessionStorage for it to not persist anymore
    sessionStorage.removeItem('query_state')

  }
  async getAllStandarPatientsDocuments(){
    let probands = []
    try{

        const payload = {
          search: this.props.searchFilter.search_text,
          gender: this.state.gender,
          maxPages: true,
          diseases: this.state.diseases,
          includeUMLS: this.state.includeUMLS,
          referrals: this.state.referrals,
          genes: this.state.genes,
          dob: this.state.dob,
          age: this.state.age,
          clinician: this.state.clinician,
          status: this.state.status,
          more_filters: this.state.more_filters
        };

        probands = await family_api.query_probands(
          this.props.user.clinician_id, payload
        );

        this.addDiseasesToProband(probands.members, probands.member_diseases)
        this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
        this.addGenesToProband(probands.members, probands.member_genes)
        this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
        this.addPatientStatus(probands.members)
        this.addSurveyAnswers(probands.members, probands.survey_answers)
        probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
        return probands.members
    }catch(err){
      console.dir(err)
    }
  }

  async getAllAdvancedPatientsDocuments(){
    let results = []
    let result_payload = {
      query_result_ID: this.state.query_result_uid,
    }

    try{
      results = await family_api.get_query_results(result_payload);
      return results
    }catch(err){
      console.dir(err)
    }
  }

  async downloadCSV() {
    this.setState({loading: true})
    let probands = []
    let advanced_filters_results = []
    if(this.state.query_result_uid.trim() == ""){
      probands = await this.getAllStandarPatientsDocuments()
    }else{
      advanced_filters_results = await this.getAllAdvancedPatientsDocuments()
    }

    let csvDownload = csvGenertor(this.state.columns, advanced_filters_results, this.state.active_advanced_filter, probands)
    this.setState({loading:false})
  }

  async copyText() {
    this.setState({loading: true})
    let probands = []
    let advanced_filters_results = []
    if(this.state.query_result_uid.trim() == ""){
      probands = await this.getAllStandarPatientsDocuments()
    }else{
      advanced_filters_results = await this.getAllAdvancedPatientsDocuments()
    }
    // let table = document.querySelector('table');
    copyGenerator(this.state.columns, advanced_filters_results, this.state.active_advanced_filter, probands)
    this.setState({loading: false})
  }

  async onSavePDF() {
    this.setState({loading: true})
    let probands = []
    let advanced_filters_results = []
    if(this.state.query_result_uid.trim() == ""){
      probands = await this.getAllStandarPatientsDocuments()
    }else{
      advanced_filters_results = await this.getAllAdvancedPatientsDocuments()
    }

    pdfGenerator(this.state.columns, advanced_filters_results, this.state.active_advanced_filter, probands)
    this.setState({loading: false})
  }

  getDocHeight() {
    var D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
  }

  async trackScrolling() {
    if (this.state.loading || !this.state.hasMore || this.state.showAdvancedFilters || (this.resultFilterRef.current && this.resultFilterRef.current.state.currentFilterPanel)) return;

    if($(window).scrollTop() + $(window).height() > this.getDocHeight() - 100) {
      console.log("bottom!");
      const new_page = this.state.page + 1;
      if(this.state.current_query_uid != ""){
        let result_payload = {
          query_result_ID: this.state.query_result_uid,
          max: MAX_PATIENTS * new_page
        }
        this.setAdvancedFiltersResults(result_payload)
        this.setState({page: new_page})
      }else{

    // if (
    //   window.innerHeight + document.documentElement.scrollTop
    //   === document.documentElement.offsetHeight
    // ) {
      // console.log('bottom reached');
      const payload = {
        search: this.props.searchFilter.search_text,
        gender: this.state.gender,
        page: new_page,
        diseases: this.state.diseases,
        referrals: this.state.referrals,
        genes: this.state.genes,
        dob: this.state.dob,
        age: this.state.age,
        clinician: this.state.clinician,
        status: this.state.status
      };

      this.setState({ loading: true, errorMessages: [] }, async () => {
        try {
          const probands = await family_api.query_probands(
            this.props.user.clinician_id, payload
          );
          this.addFamilyTimeStampToProband(probands.members, probands.family_last_modified)
          probands.members.sort((a, b) => moment(b.family_last_modified).diff(moment(a.family_last_modified)));
          this.addDiseasesToProband(probands.members, probands.member_diseases)
          this.addGenesToProband(probands.members, probands.member_genes)
          this.addPatientStatus(probands.members)
          this.addSurveyAnswers(probands.members, probands.survey_answers)
          this.addReferralCriteriasToProband(probands.members, probands.member_referral_criteria)
          let temp_probands = cloneDeep(this.state.probands);
          const new_probands = temp_probands.concat(probands.members);
          const stop_loading = probands.members.length === 0;

          this.setState({
            page: temp_probands.length === new_probands.length ? 1 : new_page,
            probands: new_probands,
            member_diseases: probands.member_diseases,
            member_genes: probands.member_genes,
            member_referral_criteria: probands.member_referral_criteria,
            records_count: probands.records_count,
            hasMore: !stop_loading
          });
        } catch (error) {
          this.setState({ errorMessages: [error.message] });
        } finally {
          this.setState({ loading: false });
        }
      });
    }
    } else {
      this.updateStickyHeader();
      console.log('not at bottom');
    }

  }

  openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  async saveClinician(result){
    if(!('clinicians' in result) && !('family' in result && 'clinicians' in result.family)) return;
    try {
      let advanced_filter_is_active = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running'
      let payload = {
        clinicians: advanced_filter_is_active ? result.family.clinicians : result.clinicians,
        proband_id: advanced_filter_is_active ? result.proband.id : result.id
      }
      await family_api.save_family_clinicians(payload)

    } catch (err) {
      console.log(err);
    }

  }

  async changeClinician(patient, clinician_array) {
    //change the clinician object of the patient from the probands state
    let advanced_filter_is_active = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running'
    let results = advanced_filter_is_active ? cloneDeep(this.state.advanced_filters_results.result) : cloneDeep(this.state.probands);
    let patient_ref = advanced_filter_is_active ? patient.proband : patient;

    for(let result of results){
      let result_id = advanced_filter_is_active ? result.proband.id : result.id
      if(patient_ref.id == result_id){
        if(advanced_filter_is_active){
          result.family.clinicians = cloneDeep(clinician_array)
          let advanced_filters_results = cloneDeep(this.state.advanced_filters_results)
          advanced_filters_results.result = results;
          this.setState({ advanced_filters_results })
        }
        else{
          result.clinicians = cloneDeep(clinician_array)
          this.setState({ probands: results })
        }
        //call saveClinician
        await this.saveClinician(result)
        break;
      }
    }

  }

  setCurrentlyActivePatientForClinicianColumn(id){
    if(this.state.currently_active_patient_for_clinician_column != id){
      this.setState({ currently_active_patient_for_clinician_column: id })
    }
  }

  setCurrentlyHoveredPatientForClinicianColumn(id){
    if(this.state.currently_hovered_patient_for_clinician_column != id){
      this.setState({ currently_hovered_patient_for_clinician_column: id })
    }
  }

  getCliniciansLabel(clinicians){
    let copy_clinicians = cloneDeep(clinicians)
    let clinicians_label = []
    for (let clinician of copy_clinicians){
      clinicians_label.push(clinician.label)
    }

    return clinicians_label.join(', ')
  }

  setShowAdvancedFilters(showAdvancedFilters){
    this.setState({ showAdvancedFilters });
  }

  compareFloats(a, b) {
    return Math.abs(a - b) < Number.EPSILON;
  }
  async setAdvancedFiltersResults(results_payload, filter_class) {
    let amountComplete = 0
    let previousAmountDone = 0
    let startTime = new Date().getTime();
    if (ac) {
      await ac.abort();
    }
    try {
      ac = new AbortController();
      const signal = ac.signal;
      this.setShowAdvancedFilters(false);
      this.setLoadingState(true);

      if (filter_class == 'advanced') {
        this.setShowAddFilters(false);
      }
      let results = await family_api.get_query_results(results_payload, signal);
      amountComplete = results.amount_done
      this.setState({ advanced_filters_results: results })

      if ('result' in results && results.result.length > 0 && this.state.loading) {
        this.setLoadingState(false);
      }

      this.setState({ filter_class })

      while (results.status != 'Completed') {
        // if user selects a patient to view or goes to any other page, then stop the background loop
        await helpers.delay(0.5);

        const pathName = window.location.pathname;
        if (!pathName.includes('query')) {
          break;
        }

        let floatsEqual = this.compareFloats(amountComplete, previousAmountDone)
        if (!floatsEqual) {
          // If it has changed, update previousAmountDone and reset the timer
          previousAmountDone = amountComplete;
          startTime = new Date().getTime();
        } else {
          // If it hasn't changed, check if 6 seconds have elapsed, if so, abort the operation
          const currentTime = new Date().getTime();
          if (currentTime - startTime >= 6000) {
            ac.abort();
            this.setState({ showQueryTimeoutModal: true });
            break;
          }
        }

        results = await family_api.get_query_results(results_payload, signal);
        amountComplete = results.amount_done
        this.setState({ advanced_filters_results: results })

        if ('result' in results && results.result.length > 0 && this.state.loading) {
          this.setLoadingState(false);
        }
        this.saveFilterSettingsToSessionStorage();
      }

      if (results.status == 'Completed') {
        this.setLoadingState(false);
        this.saveFilterSettingsToSessionStorage();
        ac = null;
      }
    }
    catch (error) {
      if (error.name === "AbortError") {
        console.log("Operation timed out");
      } else {
        console.error(error);
      }
    }
  }


  setAdvancedQueryUIDs(current_query_uid, query_result_uid){
    this.setState({ current_query_uid : current_query_uid, query_result_uid : query_result_uid })

  }

  async resetAdvancedFiltersResults(){
    let advanced_filters_results_empty = {
      status: '',
      query_result_ID: '',
      result: []
    };

    let family_filters_empty = {
      number_of_people_to_meet_criteria: {
        relationalOperator: 'any',
        value: ''
      },
      relationship: 'anyone'
    }
    this.setAdvancedQueryUIDs('', '')
    this.setShowAddFilters(true);
    this.setState({
      advanced_filters_results: advanced_filters_results_empty,
      familyFilters: family_filters_empty,
      filter_class: '',
    })
    this.setAdvancedFilters([])
    this.setActiveAdvancedFilter('probands')
  }

  setShowAddFilters(show){
    this.setState({ show_add_filters: show })

    if(!show){
      this.resultFilterRef.current.handleHideAllFilters();
      this.setState({ active_ordered_filters: [] })
    }

  }

  setAdvancedFilters(advanced_filters){
    this.setState({ advanced_filters })
  }

  setActiveAdvancedFilter(active_advanced_filter){
    this.setState({ active_advanced_filter })
  }

  setFamilyFilters(familyFilters){
    this.setState({ familyFilters })
  }

  setLoadingState(loading){
    this.setState({ loading });
  }

  saveFilterSettingsToSessionStorage(){
    let state_copy = cloneDeep(this.state);
    state_copy.search = this.props.searchFilter.search_text;
    let stringifiedState = JSON.stringify(state_copy);
    sessionStorage.setItem('query_state', stringifiedState);
  }

  handleMouseDown = (e) => {
    document.addEventListener('mouseup', this.handleDragEnd);
    const tableScrollbar = document.querySelector('.table-scrollbar');
    if (!tableScrollbar) return;

    const scrollbarRect = tableScrollbar.getBoundingClientRect();
    const clickPosition = e.clientX - scrollbarRect.left;

    const tableContainer = document.querySelector('.table-container');
    const containerWidth = tableContainer.offsetWidth;
    const contentWidth = tableContainer.scrollWidth;

    const maxScrollPosition = contentWidth - containerWidth;
    const scrollProportion = clickPosition / tableScrollbar.offsetWidth;
    const tablePositionToShow = maxScrollPosition * scrollProportion;

    tableContainer.scrollLeft = tablePositionToShow;

    this.setState({isDragging: true, scrollPosition: clickPosition})
  }

  handleDrag = (e) => {
    e.preventDefault();
    const scrollThumb = document.querySelector('.scrollbar-thumb');
    if (!scrollThumb) return;

    if (!this.state.isDragging) return;

    const x = e.clientX;
    const scrollThumbWidth = scrollThumb.offsetWidth;
    const tableContainer = document.querySelector('.table-container');
    const containerWidth = tableContainer.offsetWidth;
    const maxScrollWidth = document.querySelector('.table-custom').offsetWidth;

    const maxScrollPosition = maxScrollWidth - scrollThumbWidth;

    let scrollPosition = x;
    if (scrollPosition < 0) {
        scrollPosition = 0;
    } else if (scrollPosition > maxScrollPosition) {
        scrollPosition = maxScrollPosition;
    }

    const scrollProportion = scrollPosition / maxScrollPosition;

    const maxTableWidth = tableContainer.scrollWidth - containerWidth;
    const tablePositionToShow = maxTableWidth * scrollProportion;

    tableContainer.scrollLeft = tablePositionToShow;

    this.setState({scrollPosition});
  }

  handleDragEnd = () => {
    document.removeEventListener('mouseup', this.handleDragEnd);
    this.setState({isDragging: false});
  }

  checkOverflow = () => {
    const tableContainer = document.querySelector('.table-container');
    if (!tableContainer) return;

    const tableScrollbar = document.querySelector('.table-scrollbar');
    if (!tableScrollbar) return;

    if (tableContainer.scrollWidth > tableContainer.clientWidth) {
      if (scrollBar.display == 'none') {
        this.updateScrollbarPosition();
        scrollBar.display = 'block';
      }
    } else {
      scrollBar.display = 'none';
    }
    this.updateScrollBar();
  }

  updateScrollbarPosition = () => {
    console.log('updae scrollbar position');
    const tableHeaderHeight = document.querySelector('.table-custom thead th').offsetHeight;
    scrollBar.top = tableHeaderHeight;

    const tableContainer = document.querySelector('.table-container');
    const scrollbar = document.querySelector('.scrollbar-thumb');
    const scrollbarContainer = document.querySelector('.table-scrollbar');
    const tableCustom = document.querySelector('.table-custom');

    if (!tableContainer || !scrollbar || !scrollbarContainer || !tableCustom) return;

    const containerWidth = tableContainer.offsetWidth;
    const contentWidth = tableContainer.scrollWidth;

    const scrollRatio = containerWidth / contentWidth;
    const scrollbarWidth = containerWidth * scrollRatio / 4;

    thumb.width = scrollbarWidth < 20 ? '20px' : `${scrollbarWidth}px`;
    scrollBar.width = `${tableCustom.offsetWidth}`;

    this.updateScrollBar();
    this.updateScrollThumb();
  }

  updateStickyHeader = ()  => {
    const scrollY = window.scrollY >= 190 ? (window.scrollY || window.pageYOffset) - 190 : (window.scrollY || window.pageYOffset);

    if (window.scrollY > 225) {
      tableValues.transform = `translateY(${scrollY}px)`;
      this.updateTableStyles();
      const tableHeader = document.querySelector('.table-custom thead');
      if(tableHeader){
        scrollBar.top = tableHeader.offsetHeight + scrollY;
      }
    } else {
      tableValues.transform = `translateY(0px)`;
      this.updateTableStyles();
      const tableHeader = document.querySelector('.table-custom thead');
      if(tableHeader){
        scrollBar.top = tableHeader.offsetHeight;
      }
    }

    // this.updateScrollBar();
  }

  updateScrollBar = () => {
    const scrollbar = document.querySelector('.table-scrollbar');
    if(scrollbar){
      scrollbar.style.width = scrollBar.width == '100%' ? '100%' : `${scrollBar.width}px`;
      scrollbar.style.top = `${scrollBar.top-5}px`;
      scrollbar.style.display = scrollBar.display;
      scrollbar.style.backgroundColor = 'lightgrey';
    }
  };

  updateScrollThumb = () => {
    const scrollThumb = document.querySelector('.scrollbar-thumb');
    scrollThumb.style.width = `${thumb.width}px`;
  };

  updateTableStyles = () => {
    const tableHeader = document.querySelector('.table-custom thead');
    if(tableHeader){
      tableHeader.style.width = `${tableValues.width}px`;
      tableHeader.style.transform = tableValues.transform;
    }
  };

  render() {
    const probands = this.state.probands;

    let results = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? this.state.advanced_filters_results.result : this.state.probands
    let disableDocs = this.state.advanced_filters_results.status == 'Running' ? true : false
    return (
      <React.Fragment>

        {this.state.showAdvancedFilters ?
            <AdvancedFilters
              setAdvancedFilters={this.setAdvancedFilters}
              setAdvancedFiltersResults={this.setAdvancedFiltersResults}
              setShowAdvancedFilters={this.setShowAdvancedFilters}
              setActiveAdvancedFilter={this.setActiveAdvancedFilter}
              setFamilyFilters={this.setFamilyFilters}
              active_advanced_filter={this.state.active_advanced_filter}
              advanced_filters_results={this.state.advanced_filters_results}
              advanced_filters={this.state.advanced_filters}
              resultFilterRef={this.resultFilterRef}
              familyFilters={this.state.familyFilters}
              setLoadingState={this.setLoadingState}
              setAdvancedQueryUIDs={this.setAdvancedQueryUIDs}
              runAdvancedQuery={this.runAdvancedQuery}
              abortController={ac}
              addSurveyColumns={(columns)=>this.addSurveyColumns(columns)}
            />
          :
          <>
            <QueryToolbar
              ref={this.queryToolbarRef}
              history={this.props.history}
              user={this.props.user}
              dispatch={this.props.dispatch}
              searchFilter={this.props.searchFilter}
              updateProbands={probands => this.setState({ probands })}
              openReport={this.openSaveReportModal}
              reports={this.state.reports}
              queryProbands = {() => this.queryProbands()}
              queryProbandsNew = {() => this.queryProbandsNew()}
              loadReport={(report)=>this.loadReport(report)}
              openDeleteReportModal={(report)=> this.openDeleteReportModal(report)}
              number_of_pedigrees_on_org={this.state.number_of_pedigrees_on_org}
              />

            <br />

            <ErrorSummary errorMessages={this.state.errorMessages} />

            <ResultFilter
              ref={this.resultFilterRef}
              getSetFilterHashes={(setFilterHashes) => this.getSetFilterHashes(setFilterHashes)}
              diseaseFilterRef={this.diseaseFilterRef}
              geneTestingFilterRef={this.geneTestingFilterRef}
              referralFilterRef={this.referralFilterRef}
              moreFilterRef={this.moreFilterRef}
              onEditColumn={(columns, all_columns)=>{this.handleEditColumn(columns, all_columns)}}
              onRearrangeColumn={(columns, all_columns) =>{this.handleReorderColumns(columns, all_columns)}}
              disableDocs={disableDocs}
              downloadCSV={this.downloadCSV}
              changeDiseaseFilters={(disease_filters, includeUMLS, isActive) => this.changeDiseaseFilters(disease_filters, includeUMLS, isActive)}
              changeGeneFilters={(gene_filters, isActive)=>this.changeGeneFilters(gene_filters, isActive)}
              changeMoreFilters={(more_filters, isActive)=>this.changeMoreFilters(more_filters, isActive)}
              handleIsActiveChange={(filter_name, isActive) => this.handleIsActiveChange(filter_name, isActive)}
              changeReferralFilters={(referral_filters, isActive) => this.changeReferralFilters(referral_filters, isActive)}
              onCopy={this.copyText}
              onClearFilters={this.handleClearFilter}
              savePDF={this.onSavePDF}
              recordsCount={this.state.records_count}
              defaultColumns={this.state.allColumns}
              setShowAdvancedFilters={this.setShowAdvancedFilters}
              advanced_filters_results={this.state.advanced_filters_results}
              active_ordered_filters={this.state.active_ordered_filters}
              setActiveOrderedFilters={(active_ordered_filters) => this.setState({ active_ordered_filters })}
              runAdvancedQuery={() => this.runAdvancedQuery()}
              abortController={ac}
              active_advanced_filter={this.state.active_advanced_filter}
              show_add_filters={this.state.show_add_filters}
              queryProbands = {() => this.queryProbands()}
              queryProbandsNew={() => this.queryProbandsNew()}
              filter_class={this.state.filter_class}
            />

            <div style={{marginBottom: '2%'}}></div>

          <div className='table-container'>
            <table id="example1" className="table table-custom ">
              <thead>
                <tr>

                  {this.state.columns.map(item => {
                    return <th key={createUUID()}>{item.label}</th>
                  })}

                  {results.length > 0 && (this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running') && 'matching_members' in results[0] && (
                    <>
                      <th>Proband ID</th>
                      <th>Relationship to Proband</th>
                    </>
                  )}

                  <th></th>

                </tr>
              </thead>
              <div className='table-scrollbar'
              onMouseDown={this.handleMouseDown}
              onMouseUp={this.handleDragEnd}
              onDrag={this.handleDrag}>
                <div className='scrollbar-thumb' style={{ transform: `translateX(${this.state.scrollPosition}px)` }}></div>
              </div>
              <tbody>

                {results.map((result) => {
                  if ('matching_members' in result){
                    return(
                      result.matching_members.map(patient => {
                        let survey_answers = patient.survey_answers ? patient.survey_answers : []
                        let patientSurveyAnswers = [];
                        survey_answers.forEach(survey => {
                          if(survey.answers && typeof survey.answers === 'object'){
                            //Add all answers to the allAnswers array
                            for(let key of survey.answers){
                              //if we are adding the first answer, add it to the array
                              if(patientSurveyAnswers.length === 0)patientSurveyAnswers.push(key)
                              else{
                                let isExist = patientSurveyAnswers.some(obj => obj.question_uuid === key.question_uuid);
                                if(!isExist) patientSurveyAnswers.push(key)
                              }
                            }}else{
                            patientSurveyAnswers.push(survey)
                          }
                        });
                        return (
                          <React.Fragment key={createUUID()}>
                            <tr>
                              {this.state.columns.map((item) => {
                                if (item.value === 'dob') {
                                  return <td key={createUUID()}>{moment(patient[item.value]).format(this.getLocaleDateString())}</td>
                                } else if(item.value === 'modified_at') {
                                  return <td key={createUUID()}>{moment(result.family.last_modified.replace(/\s+/g, '')).format(this.getLocaleDateString())}</td>
                                } else if (item.value == 'diseases' && patient.diseases) {
                                  let stringForDisease = " "
                                  if (patient[item.value] !== undefined && patient[item.value] !== null) {
                                    for (let disease of patient[item.value]) {
                                      let age = disease.age_diagnosed_string ? disease.age_diagnosed_string : disease.age_diagnosed ? disease.age_diagnosed : '?'
                                      let disease_name = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? disease.disease_name : disease.name ? disease.name.disease_name : null
                                      if(disease_name){
                                        stringForDisease += disease_name + ' ' + age + ', '
                                      }else if(disease.umls_name){
                                        stringForDisease += disease.umls_name + ' ' + age + ', '
                                      }
                                    }
                                    stringForDisease = stringForDisease.slice(0, -2)
                                  }
                                  return <td key={createUUID()}>{stringForDisease}</td>
                                } else if (item.value === 'gene_summary') {
                                  var stringForGene = "";
                                  let nonNegative = [];
                                  if (patient[item.value] !== undefined && patient[item.value] !== null) {
                                    nonNegative = patient[item.value].filter(geneTest => geneTest.result !== "n");
                                    if (nonNegative.length !== 0){
                                      for(let gene of nonNegative){
                                        if(gene.result === "p") {
                                          gene.result = "Pathogenic"
                                        }
                                        else if(gene.result === "lp"){
                                          gene.result = "Likely Pathogenic"
                                        }
                                        else if(gene.result === "ln"){
                                          gene.result = "Likely Benign"
                                        }
                                        else if(gene.result === "u"){
                                          gene.result = "Unsure"
                                        }
                                        else if(gene.result === "vus"){
                                          gene.result = "VUS"
                                        }
                                        stringForGene += gene.umls_name + " " + gene.result + ', ';
                                      }
                                      stringForGene = stringForGene.slice(0, -2)
                                    }
                                    else{
                                      stringForGene = 'Negative genetic testing';
                                    }
                                  }
                                  return <td key={createUUID()}>{stringForGene}</td>
                                } else if (item.value === 'referral_criteria'){
                                  let stringforReferralCriteria = ''
                                  if((this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running') && patient.referral_criteria){
                                    let proband_referral_criteria_string = patient.referral_criteria.map(criteria => criteria.condition_name);
                                    proband_referral_criteria_string = proband_referral_criteria_string.join();
                                    stringforReferralCriteria = this.getReferralCriteriaString(proband_referral_criteria_string);
                                  }
                                  else{
                                    stringforReferralCriteria = patient["referral_criteria_string"]
                                  }
                                  return <td key={createUUID()}>{stringforReferralCriteria}</td>
                                  //display clinician here
                                } else if (item.value === 'clinician') {
                                  let label = this.getCliniciansLabel(result.family.clinicians)
                                  return (<OutsideAlerter key={createUUID()} action={() => this.setCurrentlyActivePatientForClinicianColumn('')} patientID={patient.id} setCurrentlyActivePatientForClinicianColumn={(id) => this.setCurrentlyActivePatientForClinicianColumn(id)}
                                                            setCurrentlyHoveredPatientForClinicianColumn={(id) => this.setCurrentlyHoveredPatientForClinicianColumn(id)} clinicianColumn={true}>
                                    {this.state.currently_active_patient_for_clinician_column == String(patient.id) ? <div className="form-group selectric-multiple">
                                      <div className="col-12">
                                        <Select
                                          value={result.family.clinicians}
                                          name="clinician"
                                          onChange={(clinician_array) => this.changeClinician(result, clinician_array)}
                                          className="react-select-container"
                                          classNamePrefix="react-select"
                                          isClearable={true}
                                          isMulti
                                          placeholder=""
                                          options={this.state.org_clinicians}
                                        />
                                      </div>
                                    </div>
                                      :
                                      <div style={{display: 'flex', cursor: 'pointer'}}>
                                        <div style={{flex: '1'}}>{label}</div>
                                        {this.state.currently_hovered_patient_for_clinician_column == String(patient.id) &&
                                        <div style={{alignSelf: 'flex-end'}}><a><i className="fa fa-edit"></i></a></div>}
                                      </div>}
                                  </OutsideAlerter>)
                                } else if (item.value === 'last_name' || item.value === 'first_name'){
                                  return <td key={createUUID()} className='col-1' style={{whiteSpace:'nowrap'}}>{patient[item.value]}</td>
                                } else if (item.value === 'sex_at_birth'){
                                  return <td key={createUUID()}>{patient['gender'] ? patient['gender'].toUpperCase() : 'U'}</td>
                                } else if (item.value === 'age'){
                                  return <td key={createUUID()}>{patient['age_string'] ? patient['age_string'] : patient[item.value] ? patient[item.value] : ''}</td>
                                } else if (item.value === 'patient_status'){
                                  return <td key={createUUID()}>{result.family.onboarding_status ? result.family.onboarding_status == 'complete' ? 'Complete' : result.family.onboarding_status == 'in_progress' ? 'In Progress' : '' : ''}</td>
                                } else if(item.isSurveyColumn && patientSurveyAnswers){
                                  let surveyString = ''
                                  for(let survey of patientSurveyAnswers){
                                    if(survey.master_question === item.value || survey.question_uuid === item.value){
                                      surveyString += survey.answer ? survey.answer : survey.master_question_choice ? survey.master_question_choice : ''
                                    }
                                  }
                                  return <td key={createUUID()}>{surveyString}</td>
                                }
                                else {
                                  return <td key={createUUID()}>{patient[item.value]}</td>
                                }
                              })}
                              <td className="middle">
                                {result.proband.id}
                              </td>

                              <td className="middle">
                                {patient['relation_to_proband']}
                              </td>

                              <td className="middle delete-actions">
                                <button id={`view-${patient.id}`} className="btn btn-light btn-xs table-btn-view margin-right-six" onClick={(e) => this.viewPatient(result.proband.id, "DOM", e, patient.id)}><i className="fa fa-eye"></i>&nbsp;View</button>
                                {patient.is_proband && (
                                  <a id={`delete-${patient.id}`}  type="button" onClick={() => this.openDeletePatientModal(patient)}><i className="fa fa-trash delete-custom"></i></a>
                                )}
                              </td>
                            </tr>
                          </React.Fragment>
                        )
                      }))
                  }
                  else{
                    let patient = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? result.proband : result;
                    let survey_answers = patient.survey_answers ? patient.survey_answers : []
                    let patientSurveyAnswers = [];
                    survey_answers.forEach(survey => {
                      if(survey.answers && typeof survey.answers === 'object'){
                        //Add all answers to the allAnswers array
                        for(let key of survey.answers){
                          //if we are adding the first answer, add it to the array
                          if(patientSurveyAnswers.length === 0)patientSurveyAnswers.push(key)
                          else{
                            let isExist = patientSurveyAnswers.some(obj => obj.question_uuid === key.question_uuid);
                            if(!isExist) patientSurveyAnswers.push(key)
                          }
                        }}else{
                        patientSurveyAnswers.push(survey)
                      }
                    });
                    return (
                      <React.Fragment key={createUUID()}>
                        <tr>
                          {this.state.columns.map((item) => {
                            if (item.value === 'dob') {
                              return <td key={createUUID()}>{moment(patient[item.value]).format(this.getLocaleDateString())}</td>
                            } else if(item.value === 'modified_at') {
                              let family_last_modified = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? moment(result.family.last_modified.replace(/\s+/g, '')) : moment(patient.family_last_modified.replace(/\s+/g, ''));
                              return <td key={createUUID()}>{(family_last_modified).format(this.getLocaleDateString())}</td>
                            } else if (item.value == 'diseases' && patient.diseases) {
                              let stringForDisease = " "
                              if (patient[item.value] !== undefined && patient[item.value] !== null) {
                                for (let disease of patient[item.value]) {
                                  let age = disease.age_diagnosed_string ? disease.age_diagnosed_string : disease.age_diagnosed ? disease.age_diagnosed : '?'
                                  let disease_name = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? disease.disease_name : disease.name ? disease.name.disease_name : null
                                  if(disease_name){
                                    stringForDisease += disease_name + ' ' + age + ', '
                                  }else if(disease.umls_name){
                                    stringForDisease += disease.umls_name + ' ' + age + ', '
                                  }
                                }
                                stringForDisease = stringForDisease.slice(0, -2)
                              }
                              return <td key={createUUID()}>{stringForDisease}</td>
                            } else if (item.value === 'gene_summary') {
                              var stringForGene = "";
                              let nonNegative = [];
                              if (patient[item.value] !== undefined && patient[item.value] !== null) {
                                nonNegative = patient[item.value].filter(geneTest => geneTest.result !== "n");
                                if (nonNegative.length !== 0){
                                  for(let gene of nonNegative){
                                    if(gene.result === "p") {
                                      gene.result = "Pathogenic"
                                    }
                                    else if(gene.result === "lp"){
                                      gene.result = "Likely Pathogenic"
                                    }
                                    else if(gene.result === "ln"){
                                      gene.result = "Likely Benign"
                                    }
                                    else if(gene.result === "u"){
                                      gene.result = "Unsure"
                                    }
                                    else if(gene.result === "vus"){
                                      gene.result = "VUS"
                                    }
                                    stringForGene += gene.umls_name + " " + gene.result + ', ';
                                  }
                                  stringForGene = stringForGene.slice(0, -2)
                                }
                                else{
                                  stringForGene = 'Negative genetic testing';
                                }
                              }
                              return <td key={createUUID()}>{stringForGene}</td>
                            }
                            else if(item.isSurveyColumn && patientSurveyAnswers){
                              let surveyString = ''
                              for(let survey of patientSurveyAnswers){
                                if(survey.master_question === item.value || survey.question_uuid === item.value){
                                  surveyString += (survey.answer !== null && survey.answer !== undefined) ? survey.answer 
                                  : (survey.master_question_choice !== null && survey.master_question_choice !== undefined) ? survey.master_question_choice 
                                  : '';
                                }
                              }

                              return <td key={createUUID()}>{surveyString}</td>
                            } else if (item.value === 'referral_criteria'){
                              let stringforReferralCriteria = ''
                              if((this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running') && patient.referral_criteria){
                                let proband_referral_criteria_string = patient.referral_criteria.map(criteria => criteria.condition_name);
                                proband_referral_criteria_string = proband_referral_criteria_string.join();
                                stringforReferralCriteria = this.getReferralCriteriaString(proband_referral_criteria_string);
                              }
                              else{
                                stringforReferralCriteria = patient["referral_criteria_string"]
                              }
                              return <td key={createUUID()}>{stringforReferralCriteria}</td>
                              //display clinician here
                            } else if (item.value === 'clinician') {
                              let clinicians = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? result.family.clinicians : patient.clinicians
                              let label = this.getCliniciansLabel(clinicians)
                              return (<OutsideAlerter key={createUUID()} action={() => this.setCurrentlyActivePatientForClinicianColumn('')} patientID={patient.id} setCurrentlyActivePatientForClinicianColumn={(id) => this.setCurrentlyActivePatientForClinicianColumn(id)}
                                                        setCurrentlyHoveredPatientForClinicianColumn={(id) => this.setCurrentlyHoveredPatientForClinicianColumn(id)} clinicianColumn={true}>
                                {this.state.currently_active_patient_for_clinician_column == String(patient.id) ? <div className="form-group selectric-multiple">
                                  <div className="col-12">
                                    <Select
                                      value={clinicians}
                                      name="clinician"
                                      onChange={(clinician_array) => this.changeClinician(result, clinician_array)}
                                      className="react-select-container"
                                      classNamePrefix="react-select"
                                      isClearable={true}
                                      isMulti
                                      placeholder=""
                                      options={this.state.org_clinicians}
                                    />
                                  </div>
                                </div>
                                  :
                                  <div style={{display: 'flex', cursor: 'pointer'}}>
                                    <div style={{flex: '1'}}>{label}</div>
                                    {this.state.currently_hovered_patient_for_clinician_column == String(patient.id) &&
                                    <div style={{alignSelf: 'flex-end'}}><a><i className="fa fa-edit"></i></a></div>}
                                  </div>}
                              </OutsideAlerter>)
                            } else if (item.value === 'last_name' || item.value === 'first_name'){
                              return <td key={createUUID()} className='col-1' style={{whiteSpace:'nowrap'}}>{patient[item.value]}</td>
                            } else if (item.value === 'sex_at_birth'){
                              return <td key={createUUID()}>{patient['gender'] ? patient['gender'].toUpperCase() : 'U'}</td>
                            } else if (item.value === 'age'){
                              return <td key={createUUID()}>{patient['age_string'] ? patient['age_string'] : patient[item.value] ? patient[item.value] : ''}</td>
                            } else if (item.value === 'patient_status'){
                              let onboarding_status = this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running' ? result.family.onboarding_status : patient.patient_status;

                              if(this.state.advanced_filters_results.status == 'Completed' || this.state.advanced_filters_results.status == 'Running'){
                                onboarding_status = result.family.onboarding_status ? result.family.onboarding_status == 'complete' ? 'Complete' : result.family.onboarding_status == 'in_progress' ? 'In Progress' : '' : '';
                              }
                              return <td key={createUUID()}>{onboarding_status}</td>
                            } else {
                              return <td key={createUUID()}>{patient[item.value]}</td>
                            }
                          })}

                          <td className="middle delete-actions">
                            <button id={`view-${patient.id}`} className="btn btn-light btn-xs table-btn-view margin-right-six" onClick={(e) => this.viewPatient(patient.id, "DOM", e)}><i className="fa fa-eye"></i>&nbsp;View</button>
                            <a id={`delete-${patient.id}`}  type="button" onClick={() => this.openDeletePatientModal(patient)}><i className="fa fa-trash delete-custom"></i></a>
                          </td>
                        </tr>
                      </React.Fragment>
                    )
                  }
                })}

              </tbody>
            </table>
          </div>

            {this.state.showDeletePatientModal && (
              <ModalDeletePatient
                patient={this.state.currentPatient}
                onClose={this.closeDeletePatientModal}
                onClickDelete={(payload) => this.onDeletePatient(payload)}
              />
            )}

            {this.state.showSaveReport && (
              <ModalSaveReport
                onClose={this.closeReportModal}
                onClickSave={(reportTitle)=>this.saveNewReport(reportTitle)}
              />
            )}
            
            {this.state.showQueryTimeoutModal && (
              <QueryTimeoutModal
                onClose={this.closeQueryTimeoutModal}
              />
            )}

            {this.state.showOverwriteReport[0] && (
              <ModalOverwriteReport
                onClose={this.closeOverwriteReportModal}
                reportTitle={this.state.showOverwriteReport[1]}
                onClickSave={(reportTitle) => this.overWriteReport(reportTitle)}
              />
            )}

            {this.state.showDeleteReportModal[0] && (
              <ModalConfirmReportDelete
                title="Delete Report"
                message="Are you sure you would like to delete this report?"
                isOpen={this.state.showDeleteReportModal[0]}
                onCancel={() => this.setState({ showDeleteReportModal: [false, ''] })}
                onOk={() => this.deleteReport()}
                loading={this.state.loading}
                errorMessages={this.state.errorMessages}
              />
            )}

            <ActivityIndicator loading={this.state.loading} modal={true} />
          </>
        }


      </React.Fragment>
    )
  }
}

const redux_state = state => ({
  user: state.session.user,
  searchFilter: state.search.searchFilter,
  static_list: state.static_list,
  org_clinicians: state.session.user.org_clinicians
});

const redux_actions = dispatch => ({
  dispatch: action => dispatch(action)
});

export default connect(
  redux_state,
  redux_actions,
  null,
  { forwardRef: true }
)(ResultList);
